import { File } from './../../models/files/files.model';

export class Designbox {
    id?: string;
    [content: string]: any;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        this.file = options.file;
    }
}
